var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserDefaultAvatar = function SvgUserDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm0 4.645C13.302 4.645 4.645 13.303 4.645 24c0 3.337.843 6.475 2.327 9.214a10.89 10.89 0 0 1 6.52-5.475 12.445 12.445 0 0 1-2.024-6.836c0-6.927 5.606-12.532 12.532-12.532 6.927 0 12.532 5.606 12.532 12.532 0 2.465-.707 4.82-2.025 6.836a10.89 10.89 0 0 1 6.521 5.475A19.284 19.284 0 0 0 43.355 24c0-10.698-8.658-19.355-19.355-19.355z"
  }))));
};
export default SvgUserDefaultAvatar;